import { render, staticRenderFns } from "./JoinToLb.vue?vue&type=template&id=12cdfd1a&scoped=true"
import script from "./JoinToLb.vue?vue&type=script&lang=js"
export * from "./JoinToLb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cdfd1a",
  null
  
)

export default component.exports